import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { Router } from '@angular/router';
// @ts-ignore
import { fadeInUp400ms } from '@vex/animations/fade-in-up.animation';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import {
  ErrorStateMatcher,
  ShowOnDirtyErrorStateMatcher
} from '@angular/material/core';
import { NgIf } from '@angular/common';
import { StorageService } from '../../shared/services/storage.service';
import { AuthService } from '../../shared/services/auth.service';
import { GlobalService } from '../../shared/services/global.service';
import { HeaderComponent } from '../../landing/header/header.component';
import { FooterComponent } from '../../landing/footer/footer.component';

@Component({
  selector: 'vex-superadmin-login',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    NgIf,
    ReactiveFormsModule,
    HeaderComponent,
    FooterComponent
  ],
  templateUrl: './superadmin-login.component.html',
  styleUrls: ['./superadmin-login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeInUp400ms],
  providers: [
    GlobalService,
    AuthService,
    { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher }
  ]
})
export class SuperAdminLoginComponent implements OnInit {
  loginForm: FormGroup = new FormGroup({});
  inputType: any = 'password';
  visible: any = false;
  submitted: any = false;
  errorMessage: string = '';

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private authService: AuthService,
    private globalService: GlobalService
  ) {
    if (StorageService.getItem('accessToken') && StorageService.getItem('self')) {
      const self = StorageService.getItem('self');
      if (self?.user_type === 'SUPERADMIN') {
        window.location.href = '/organisations';
      }
    }
  }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  toggleVisibility(): void {
    this.visible = !this.visible;
    this.inputType = this.visible ? 'text' : 'password';
    this.cd.markForCheck();
  }

  login(): void {
    this.submitted = true;
    this.errorMessage = '';
    if (!this.loginForm.valid) {
      return;
    }
    const params = {
      username: this.loginForm.getRawValue().username,
      password: this.loginForm.getRawValue().password
    };
    this.authService.login(params).subscribe(
      (data) => {
        if (data && data.id && data.user_type === 'SUPERADMIN') {
          this.globalService.setAccessToken(data?.token);
          this.globalService.setSelf({
            name: data?.name,
            email: data?.email,
            user_id: data?.id,
            username: data?.username,
            user_type: data?.user_type
          });
          // Full page navigation (not router.navigateByUrl) so the app
          // re-bootstraps with the now-populated storage -- the sidenav
          // is built once at app start and otherwise stays stale until
          // a hard reload.
          window.location.href = '/organisations';
        } else {
          this.errorMessage = 'Invalid superadmin credentials.';
        }
      },
      () => {
        this.errorMessage = 'Invalid superadmin credentials.';
      }
    );
  }

  goTo(url: string): void {
    this.router.navigateByUrl(url);
  }
}
